import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/SmartCool-LOGO.png";

const links = [
  { label: "Home",               path: "/"             },
  { label: "About Us",           path: "/about"        },
  { label: "Services",           path: "/services"     },
  { label: "Smart Stores",       path: "/smart-stores" },
  { label: "Industries We Serve",path: "/industries"   },
  { label: "Blog",               path: "/blog"         },
  { label: "Contact Us",         path: "/contact"      },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="SmartCool Logo" className="h-8 sm:h-10 w-auto" />
        </Link>

        {/* Desktop Links */}
        <ul className="hidden lg:flex gap-4 xl:gap-6 text-sm font-medium text-gray-700 font-poppins">
          {links.map((l) => (
            <li key={l.path}>
              <Link
                to={l.path}
                className="pb-1 transition-colors whitespace-nowrap"
                style={
                  location.pathname === l.path
                    ? { color: "#21CFF3", borderBottom: "2px solid #21CFF3" }
                    : { borderBottom: "2px solid transparent", color: "#374151" }
                }
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Hamburger */}
        <button
          className="lg:hidden text-gray-600 text-2xl p-2"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <ul className="lg:hidden bg-white border-t px-4 py-2 flex flex-col font-poppins shadow-md">
          {links.map((l) => (
            <li key={l.path}>
              <Link
                to={l.path}
                onClick={() => setMenuOpen(false)}
                className="block py-3 border-b border-gray-100 text-sm font-medium transition-colors"
                style={
                  location.pathname === l.path
                    ? { color: "#21CFF3" }
                    : { color: "#0F1030" }
                }
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}